import React from 'react'

import {
  CtaContent,
  CtaWrap,
} from './styles'

const CtaTwoCol: React.FC = ({ children }): React.ReactElement => (
  <CtaWrap>
    <CtaContent>
      {children}
    </CtaContent>
  </CtaWrap>
)

export default CtaTwoCol
